module.exports = __webpack_public_path__ + "static/media/HBAR.28eed290.svg";